import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
export default function BasicDatePicker({
  date,
  setDate,
  placeholder = '날짜를 선택해주세요.',
  ...rest
}: any) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        value={date}
        slotProps={{ textField: { size: 'small' } }}
        maxDate={new Date()}
        format="yyyy - MM - dd"
        onChange={newDate => {
          setDate(newDate);
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
}
